import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '../services/auth/authentication.service';

@Directive({
  selector: '[appHasAnyPermission]',
  standalone: true,
})
export class HasAnyPermissionDirective {
  @Input()
  set appHasAnyPermission(permissions: string[] | undefined) {
    if (
      !permissions ||
      permissions.length === 0 ||
      this.authorizationService.hasAnyPermission(permissions)
    ) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainerRef.clear();
    }
  }

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly authorizationService: AuthenticationService,
  ) {}
}
